module.exports = __webpack_public_path__ + "img/2604_sapporo_collection.18e0d9f1.png";